import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Rating } from 'components';
import styles from './ReviewsTotal.module.scss';

const ReviewsTotal = ({ rating, reviews }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.average}>
        {rating}
        <Rating
          size={28}
          value={rating === 0 ? 5 : rating}
          color={rating === 0 ? 'default' : 'primary'}
        />
      </div>
      <p className={styles.total}>
        {t('product:reviews')}: {reviews.length}
      </p>
      {[5, 4, 3, 2, 1].map(value => {
        const amount = reviews.reduce(
          (acc, review) => (review.rate === value ? (acc += 1) : acc),
          0,
        );
        return (
          <Fragment key={value}>
            <div className={styles.row}>
              <Rating
                size={18}
                value={value}
                color={rating === 0 ? 'default' : 'primary'}
                hideEmpty
              />
              {amount}
            </div>
            <div className={styles.scale}>
              <div
                className={styles.scaleIndicator}
                style={{ width: `${(100 / reviews.length) * amount}%` }}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default ReviewsTotal;
